import z from "zod";
import { worksites } from "../../../attendances";
import { geoCoordinatesSchema } from "../../geo-coordinates";

/**
 * The body of a worksite change: the target is optional because only a commute offers a choice of
 * next worksite; from a project site or a warehouse the chain has exactly one, and the server
 * (`insertWorksiteMigration`) falls back to it when none is sent. The acknowledgements are those
 * of the target worksite, which the attendance the change starts is subject to like any other
 * check-in.
 */
export const postAttendanceMigrateWorksiteBodySchema = z
	.object({
		targetWorksite: z.enum(worksites).optional(),
		commuteProjectId: z.uuid().optional(),
		acknowledgedDefinitionIds: z.array(z.uuid()).optional(),
		acknowledgedRiskAssessments: z.boolean().optional(),
	})
	.extend(geoCoordinatesSchema);

export type PostAttendanceMigrateWorksiteBodySchema = z.infer<
	typeof postAttendanceMigrateWorksiteBodySchema
>;
